'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Block = require('./Block');

var _Block2 = _interopRequireDefault(_Block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Block2.default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/Block/index.js
// module id = 1723
// module chunks = 0